/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CommunityManagerResponse } from './';
import {
    CommunityManagerResponseFromJSON,
    CommunityManagerResponseFromJSONTyped,
    CommunityManagerResponseToJSON,
} from './';
import type { CountryManagerResponse } from './';
import {
    CountryManagerResponseFromJSON,
    CountryManagerResponseFromJSONTyped,
    CountryManagerResponseToJSON,
} from './';
import type { SalesManagerResponse } from './';
import {
    SalesManagerResponseFromJSON,
    SalesManagerResponseFromJSONTyped,
    SalesManagerResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllManagerResponse
 */
export interface AllManagerResponse {
    /**
     * 
     * @type {Array<SalesManagerResponse>}
     * @memberof AllManagerResponse
     */
    salesManagers: Array<SalesManagerResponse>;
    /**
     * 
     * @type {Array<CommunityManagerResponse>}
     * @memberof AllManagerResponse
     */
    communityManagers: Array<CommunityManagerResponse>;
    /**
     * 
     * @type {Array<CountryManagerResponse>}
     * @memberof AllManagerResponse
     */
    countryManagers: Array<CountryManagerResponse>;
}

/**
 * Check if a given object implements the AllManagerResponse interface.
 */
export function instanceOfAllManagerResponse(value: object): value is AllManagerResponse {
    if (!('salesManagers' in value) || value['salesManagers'] === undefined) return false;
    if (!('communityManagers' in value) || value['communityManagers'] === undefined) return false;
    if (!('countryManagers' in value) || value['countryManagers'] === undefined) return false;
    return true;
}

export function AllManagerResponseFromJSON(json: any): AllManagerResponse {
    return AllManagerResponseFromJSONTyped(json, false);
}

export function AllManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'salesManagers': ((json['salesManagers'] as Array<any>).map(SalesManagerResponseFromJSON)),
        'communityManagers': ((json['communityManagers'] as Array<any>).map(CommunityManagerResponseFromJSON)),
        'countryManagers': ((json['countryManagers'] as Array<any>).map(CountryManagerResponseFromJSON)),
    };
}

export function AllManagerResponseToJSON(value?: AllManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'salesManagers': ((value['salesManagers'] as Array<any>).map((v) => SalesManagerResponseToJSON(v))),
        'communityManagers': ((value['communityManagers'] as Array<any>).map((v) => CommunityManagerResponseToJSON(v))),
        'countryManagers': ((value['countryManagers'] as Array<any>).map((v) => CountryManagerResponseToJSON(v))),
    };
}

